import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheckCircle,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";
import whiteLogo from "@logos/RDEC-WHITE-NOBG-SMALL.png";

const categories = [
  "Válvulas industriais",
  "Automação e controle",
  "Conexões e Flanges para Tubulação",
  "Limpeza de Painéis Elétricos",
  "Equipamentos subaquáticos",
  "E muito mais",
];

export default function PortfolioIntroduction() {
  return (
    <section
      id={"portfolio-introduction"}
      className="flex h-auto flex-col items-center justify-evenly bg-white px-10 lg:h-[65vh] lg:flex-row"
    >
      <div className="flex w-full max-w-6xl flex-col justify-evenly gap-4 p-4 lg:flex-row">
        {/* Left Side */}
        <div className={`flex w-full flex-col space-y-4 p-4`}>
          <div className="flex items-center space-x-3">
            <div className="rounded-lg bg-primary-700 p-3">
              <FontAwesomeIcon icon={faCogs} className="h-6 w-6 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800">
              Produtos e Soluções
            </h2>
          </div>
          <h3 className="mt-4 text-3xl font-bold text-gray-900">
            Das simples às mais complexas:{" "}
            <span className="text-primary-700">um portfólio completo</span>
          </h3>
          <p className="mt-3 text-gray-700">
            Nós disponibilizamos uma opções variadas de produtos e serviços de
            automação das empresas mais bem renomadas do mercado.
          </p>
          <p className="mt-4 font-semibold text-gray-900">
            O que você encontra atualmente:
          </p>
          <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2">
            {categories.map((category, index) => (
              <div key={index} className="flex items-center space-x-2">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className="h-5 w-5 text-blue-500"
                />
                <span className="text-gray-800">{category};</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side */}
        <div
          className={`hidden flex-col items-center justify-evenly rounded-lg bg-primary-700 p-12 text-center text-white md:flex`}
        >
          <img
            className="flex w-2/3 items-center justify-center"
            alt={`Restart Design & Consulting white logo`}
            src={whiteLogo}
          />
          <h3 className="mt-4 text-2xl font-bold">Precisa de ajuda?</h3>
          <p className="mt-2 text-gray-300">
            Solicite contato da nossa equipe.
          </p>
          <button
            className="mt-6 rounded-lg bg-white px-6 py-3 font-semibold text-black transition-all hover:bg-gray-300 active:bg-gray-400"
            onClick={() => (window.location.href = "/contact-us")}
          >
            ENTRAR EM CONTATO
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </button>
        </div>
      </div>
    </section>
  );
}
